import type { ReactNode } from "react";

interface CustomHrefProps {
  text?: ReactNode;
  link?: string;
  type?: "redirect" | "target";
  color?: string;
  textDecoration?: string;
}

function CustomHref({
  text,
  link,
  type = "redirect",
  color = "#d91266",
  textDecoration = "underline",
}: CustomHrefProps) {
  const style = {
    color,
    textDecoration,
    fontWeight: "bold",
    cursor: "pointer" as const,
  };

  if (link === undefined) {
    return <span style={style}>{text}</span>;
  }

  if (type === "redirect") {
    return (
      <a style={style} href={link}>
        {text}
      </a>
    );
  }

  return (
    <a style={{ ...style, cursor: undefined }} href={link} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  );
}

export default CustomHref;
